import LoaderPage from 'components/ui/feedback/LoaderPage'
import React, { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const OverAdvances = lazy(() => import('pages/overAdvances/page'))
const OverAdvancePreviewPage = lazy(() => import('pages/overAdvances/[overAdvanceId]/page'))
const OverAdvanceTemplatesPage = lazy(() => import('pages/overAdvanceTemplates/page'))

const OverAdvancesRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<OverAdvances />} />} />
      <Route path="/templates" element={<LoaderPage content={<OverAdvanceTemplatesPage />} />} />
      <Route path="/:referenceNumber/:overAdvanceId" element={<LoaderPage content={<OverAdvancePreviewPage />} />} />
    </Routes>
  )
}

export default OverAdvancesRoutes
